export const findDocument = (documentResponseList, docType, field) => {
	return documentResponseList?.find((doc) => doc?.docType === docType)?.[field];
};

export const formatArtworkResponse = (artWorkResponse) => {
	const findFileType = artWorkResponse?.documentResponseList?.find(
		(item) => item?.docType === 'ARTWORK_ILLUSTRATOR_FILE' || 'ARTWORK_PHOTOSHOP_FILE'
	);

	const formattedArtworkResponse = {
		...artWorkResponse,
		brand: {
			...artWorkResponse?.brandResponse,
			value: artWorkResponse?.brandResponse?.text
		},
		id: artWorkResponse?.id,
		season: {
			...artWorkResponse?.seasonTagResponse,
			value: artWorkResponse?.seasonTagResponse?.text
		},
		theme: {
			...artWorkResponse?.artworkThemeTagResponse,
			value: artWorkResponse?.artworkThemeTagResponse?.text
		},
		designedBy: {
			...artWorkResponse?.designedByResponse,
			value: artWorkResponse?.designedByResponse?.name
		},
		imageId: findDocument(artWorkResponse?.documentResponseList, 'ARTWORK_FRONT_IMAGE', 'id'),
		fileId: findDocument(
			artWorkResponse?.documentResponseList,
			findFileType?.docType || 'ARTWORK_ILLUSTRATOR_FILE',
			'id'
		),
		comments: artWorkResponse?.remarks,
		tag: artWorkResponse?.tagResponseList?.map((tag) => ({
			id: tag?.id,
			text: tag?.text,
			label: tag?.text
		})),
		fileName: findDocument(
			artWorkResponse?.documentResponseList,
			findFileType?.docType || 'ARTWORK_ILLUSTRATOR_FILE',
			'name'
		)?.split('.')[0]
	};
	return formattedArtworkResponse;
};

export const validateArtwork = (artworkState, setErrors) => {
	const errors = {};
	if (!artworkState?.season) {
		errors.season = 'Season is required';
	}
	if (!artworkState?.designedBy?.id) {
		errors.designedBy = 'Designed by is required';
	}
	if (!artworkState?.fileId) {
		errors.file = 'Artwork file is required';
	}
	if (!artworkState?.imageId) {
		errors.image = 'Artwork image is required';
	}

	setErrors(errors);
	return Object.keys(errors).length === 0;
};

export const getChangedFields = (artworkState, originalState) => {
	if (!originalState) return {};

	const changes = {};

	if (artworkState?.fileName !== originalState?.fileName) {
		changes.fileName = artworkState?.fileName?.split('.')[0];
	}

	if (artworkState?.comments !== originalState?.comments) {
		changes.remarks = artworkState?.comments;
	}

	if (artworkState?.brand?.id !== originalState?.brand?.id) {
		changes.brandId = artworkState?.brand?.id;
	}

	if (artworkState?.designedBy?.id !== originalState?.designedBy?.id) {
		changes.designedById = artworkState?.designedBy?.id;
	}

	if (artworkState?.season?.id !== originalState?.season?.id) {
		changes.seasonTagRequest = {
			id: artworkState?.season?.id,
			text: artworkState?.season?.value
		};
	}

	if (artworkState?.theme?.id !== originalState?.theme?.id) {
		changes.themeTagRequest = {
			id: artworkState?.theme?.id,
			text: artworkState?.theme?.value
		};
	}

	const changedDocumentIds = [];
	if (artworkState?.imageId !== originalState?.imageId && artworkState?.imageId) {
		changedDocumentIds.push(artworkState?.imageId);
	}
	if (artworkState?.fileId !== originalState?.fileId && artworkState?.fileId) {
		changedDocumentIds.push(artworkState?.fileId);
	}

	if (changedDocumentIds.length > 0) {
		changes.documentIds = changedDocumentIds;
	}

	const originalTags = originalState?.tag || [];
	const currentTags = artworkState?.tag || [];

	const tagsChanged =
		originalTags.length !== currentTags.length ||
		originalTags.some((tag, index) => tag?.text !== currentTags[index]?.text);

	if (tagsChanged) {
		changes.tags = artworkState?.tag?.map((item) => ({ text: item?.label, id: item?.id }));
	}

	return changes;
};

export const createRequestBody = (artworkState) => {
	const requestBody = {
		fileName: artworkState?.fileName?.split('.')[0],
		remarks: artworkState?.comments || null,
		brandId: artworkState?.brand?.id,
		designedById: artworkState?.designedBy?.id,
		seasonTagRequest: {
			id: artworkState?.season?.id || null,
			text: artworkState?.season?.value
		},
		themeTagRequest: artworkState?.theme?.value
			? {
					id: artworkState?.theme?.id || null,
					text: artworkState?.theme?.value
				}
			: null,
		documentIds: [artworkState?.imageId, artworkState?.fileId],
		tags: artworkState?.tag?.map((item) => ({ text: item?.label, id: item?.id })) || null
	};

	if (requestBody?.tags?.length === 0) {
		delete requestBody.tags;
	}

	if (!requestBody?.themeTagRequest) {
		delete requestBody.themeTagRequest;
	}

	return requestBody;
};

export const getArtworkStatus = (status) => {
	switch (status) {
		case 'SOLD':
			return 'red-3';
		case 'UNUSED':
			return 'green-1';
		case 'USED':
			return 'yellow-1';
		default:
			return 'gray-1';
	}
};

export const sliceText = (text = '', length = 10) => {
	return text
		.slice(0, length)
		.concat('...')
		.concat(text.length > length ? text.slice(text.length - length) : '');
};

export const getFileType = (file = '') => {
	return file === 'application/postscript' ? 'ARTWORK_ILLUSTRATOR_FILE' : 'ARTWORK_PHOTOSHOP_FILE';
};

export const getDocType = (documentType) => {
	return documentType === 'ARTWORK_ILLUSTRATOR_FILE' || documentType === 'ARTWORK_PHOTOSHOP_FILE';
};
